import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=03ab6e6d&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=03ab6e6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ab6e6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03ab6e6d')) {
      api.createRecord('03ab6e6d', component.options)
    } else {
      api.reload('03ab6e6d', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=03ab6e6d&scoped=true&", function () {
      api.rerender('03ab6e6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4cbF6juT703ja/JS/comp/DocBox.vue"
export default component.exports